import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import { Badge, StatusDot } from './Primitives';
import {
  powerStateMeta,
  identityStatusMeta,
  heartbeatMeta,
} from '../utils/constants';
import { vmProducts, isVmIdentityAmbiguous } from '../utils/format';

/** Badge dei prodotti della VM (tutti i prodotti, per le VM multiprodotto). */
export function ProductBadges({ vm, className = '' }) {
  const products = vmProducts(vm);
  if (products.length === 0) {
    return (
      <span className="text-xs text-gray-400 dark:text-gray-500">
        Nessun prodotto
      </span>
    );
  }
  return (
    <span className={`flex flex-wrap gap-1 ${className}`}>
      {products.map((p) => (
        <Badge
          key={p}
          className="bg-primary/10 text-primary dark:bg-primary/20"
        >
          {p}
        </Badge>
      ))}
    </span>
  );
}

/** Badge dello stato di alimentazione (colore + icona implicita + testo). */
export function PowerStateBadge({ state }) {
  const meta = powerStateMeta(state);
  return (
    <Badge className={meta.badge}>
      <span className={`h-2 w-2 rounded-full ${meta.dot}`} aria-hidden="true" />
      {meta.label}
    </Badge>
  );
}

/**
 * Badge dell'identità: mostrato solo quando è utile segnalare un'anomalia.
 * Per le VM verificate (MATCHED e non presenti negli avvisi) non ingombra la UI.
 */
export function IdentityBadge({ vm, catalogWarnings }) {
  const ambiguous = isVmIdentityAmbiguous(vm, catalogWarnings);
  if (!ambiguous) return null;
  const meta = identityStatusMeta(vm.identityStatus);
  return (
    <Badge className={meta.style} title="Identità della VM non verificata">
      <FaExclamationTriangle size={10} aria-hidden="true" />
      {meta.label}
    </Badge>
  );
}

/** Heartbeat come pallino colorato + etichetta. */
export function HeartbeatIndicator({ status }) {
  const meta = heartbeatMeta(status);
  return <StatusDot dotClass={meta.dot} label={meta.label} title={`Heartbeat: ${meta.label}`} />;
}
